import { FunctionComponent } from 'react';
import { VGDisclaimerFooter } from '../../../components/VGDisclaimerFooter/VGDisclaimerFooter';
import { usePropertyPageModalContext } from '../../contexts/PropertyPageModalContext/PropertyPageModalContext';
import { trackDisclaimerModalOpen } from '../../../analytics/event-tracking/trackDisclaimerModalOpen';
import { styled } from 'styled-components';
import {
  mediaHelper,
  paletteHelper,
  spacingHelper,
  typographyHelper,
} from '@property.com.au/ui-kit';
import { OutboundLink } from '../../../app-kit/components/OutboundLink/OutboundLink';

const Wrapper = styled.div`
  padding-bottom: ${spacingHelper('large')};

  ${mediaHelper('tabletMax')} {
    padding-left: ${spacingHelper('large')};
    padding-right: ${spacingHelper('large')};
  }

  > div {
    margin: 0 auto;
    max-width: 850px;
    width: 100%;
  }
`;

const PropensityDisclaimerFooter = styled.div`
  padding-bottom: ${spacingHelper('medium')};

  ${typographyHelper('body02')}
  color: ${paletteHelper('textSecondary')};
`;

const StyledOutboundLink = styled(OutboundLink)`
  text-decoration: none;
`;

export const PropertyPageVGDisclaimerFooter: FunctionComponent = () => {
  const { displayModal } = usePropertyPageModalContext();

  return (
    <Wrapper>
      <VGDisclaimerFooter
        onDisclaimerLinkClick={() => {
          displayModal({ name: 'propertyPageDataDisclaimer' });
          trackDisclaimerModalOpen({
            inPageSource: ['property_page', 'footer_disclaimer', 'button'].join('__'),
          });
        }}
      />
      <PropensityDisclaimerFooter>
        Inferred data based on user page interactions (including in relation to specific properties)
        may be disclosed by REA to its customers, including agents. For more information, please see
        our{' '}
        <StyledOutboundLink
          href={'https://www.realestate.com.au/legal/privacy-policy'}
          outboundLinkType={'propensity_disclaimer_privacy_policy'}
          variant={'inline'}
        >
          privacy policy
        </StyledOutboundLink>
        .
      </PropensityDisclaimerFooter>
    </Wrapper>
  );
};
